module.exports = __webpack_public_path__ + "static/Feature2-ede1dd5a3c091557b1711db09d38235f.jpg";